import React, { useEffect, useState } from "react";
import { UpdatePasswordApi } from '../api/user';
import { UseAuth } from '../hooks/useAuth';

const NewPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  
  // Obtenemos la información de autenticación una vez
  const { user } = UseAuth();
  const email = user.EMAIL;
  const { accessToken, logout } = UseAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validar que las contraseñas coincidan
    if (password !== confirmPassword) {
      setMessage("Las contraseñas no coinciden.");
      return;
    }

    const usuario = {
      email: email,
      password: password
    }
    const result = await UpdatePasswordApi(accessToken, usuario);
    setMessage("Contraseña actualizada correctamente. Redirigiendo a Acceso de usuario");
    if (result.code = 200 ){
      setTimeout(() => {
      logout()
    }, 3000);

    }
  };

  return (
    <div className='login'>
      <h2>Nueva Contraseña</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="password">Nueva Contraseña:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="confirmPassword">Confirmar Nueva Contraseña:</label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        <button type="submit">Guardar</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
}

export default NewPassword;
